/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react' //, {useState}
import FeaturesCrud from '../../modules/custom/ManageSuscription/SuscriptionsTable'

const Features: React.FC = () => {
 

  return (
    <>
      {/*<div className="d-flex flex-column-auto h-60px bg-info-td border-rounded flex-center border rounded">
        <h3 className='text-secondary'> Subscriptions List</h3>
  </div>*/}

      <div  className='card mb-5 mb-xl-5'>
          <FeaturesCrud></FeaturesCrud>
      </div>
    </>
  )
}

export {Features}
